import { Outlet, useLocation } from 'react-router-dom'

import PageSection from '@/components/public/PageSection'
import TranslateWarning from '@/components/TranslateWarning'

export default function PublicLayout() {
	const { pathname } = useLocation()
	const hideAside = pathname === '/tuition'

	return (
		<PageSection showAside={!hideAside}>
			<TranslateWarning />
			<Outlet />
		</PageSection>
	)
}
